// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__kfULk","rightAdornment":"Header_rightAdornment__3fHc7"};